// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_g6-0";
export var actionModalContentContainer = "_g6-1";
export var createTagButton = "_g6-2";
export var footerContainer = "_g6-7";
export var fullWidthDivider = "_g6-3";
export var hasCreateTagButton = "_g6-4";
export var noCreateTagButton = "_g6-5";
export var tagsContainer = "_g6-6";
export var tagsModalContentContainer = "_g6-8";